import src from "IMAGE";
export default { src, width: 5760, height: 3168, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAMElEQVR42nXMMQ4AMAhCURct3v/A1CZ0MTq8iR+MpDdRjoQNI0pugWtIwRT86D3hAgk6YGdqqDJXAAAAAElFTkSuQmCC", blurWidth: 8, blurHeight: 4 }
